import { __extends } from "tslib";
import { deserializeAws_restXmlDeleteBucketPolicyCommand, serializeAws_restXmlDeleteBucketPolicyCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteBucketPolicyCommand = /** @class */ (function (_super) {
    __extends(DeleteBucketPolicyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteBucketPolicyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteBucketPolicyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteBucketPolicyCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlDeleteBucketPolicyCommand(input, context);
    };
    DeleteBucketPolicyCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlDeleteBucketPolicyCommand(output, context);
    };
    return DeleteBucketPolicyCommand;
}($Command));
export { DeleteBucketPolicyCommand };
//# sourceMappingURL=DeleteBucketPolicyCommand.js.map